import React from 'react';
import classNames from 'styles/utils/classNames';
import type { SkeletonProps } from './types';

export default function Skeleton({
  width = 'w-full',
  height = 'h-4',
  className,
  variant = 'rect',
  rounded = 'md',
}: SkeletonProps) {
  const baseClasses =
    'bg-gradient-to-r from-palette-black-3 via-palette-black-4 to-palette-black-3 bg-[length:200%_100%] animate-shimmer';

  const roundedClasses = {
    sm: 'rounded-sm',
    md: 'rounded-md',
    lg: 'rounded-lg',
    full: 'rounded-full',
  };

  const variantClasses = variant === 'circle' ? 'rounded-full' : '';

  return (
    <div
      role="status"
      aria-busy="true"
      aria-live="polite"
      className={classNames(
        baseClasses,
        width,
        height,
        variantClasses || roundedClasses[rounded],
        className,
      )}
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
}
